import React, { useState, useEffect } from 'react'
import { SingleSelectFilter } from '@offerzen/pinata'
import styles from './style'
import PropTypes from 'prop-types'
import { useFilters } from 'clientHelpers/context/filtersContext'

const SingleSelectFilterRolesFilter = ({ roles, existingValue }) => {
  const { setFilterValues, ...filters } = useFilters()
  const [roleValue, setRoleValue] = useState('')
  const [selectedRole, setSelectedRole] = useState(null)
  const [filteredRoles, setFilteredRoles] = useState([])
  const [results, setResults] = useState([])
  const [showHelpText, setShowHelpText] = useState(false)

  useEffect(() => {
    if (!filters.roles?.length && selectedRole !== null) {
      setRoleValue('')
      setSelectedRole(null)
    }
  }, [selectedRole, filters])

  useEffect(() => {
    const mappedRoles =
      roles?.map(role => {
        return { label: role.name, value: role.name }
      }) ?? []
    setFilteredRoles(mappedRoles)
  }, [roles])

  useEffect(() => {
    if (roleValue.length <= 0 || roleValue === null) {
      setResults(filteredRoles)
    }

    const searchResults = filteredRoles.filter(role => role?.label?.toLowerCase().includes(roleValue?.toLowerCase()))

    if (searchResults.length > 0) {
      setShowHelpText(false)
      setResults(searchResults)
    } else {
      setShowHelpText(true)
      setResults([])
    }
  }, [roleValue, filteredRoles])

  return (
    <section role="role-filter" className={styles.filterBlock}>
      <label className={styles.label}>Role</label>
      <SingleSelectFilter
        placeholder={'Search role' || roleValue}
        label="Role"
        results={results}
        value={existingValue || roleValue}
        onChange={value => {
          setRoleValue(value.label)
          setSelectedRole(value.label)
          setFilterValues({
            roles: [value],
          })
        }}
        helpText={showHelpText && 'Choose from available roles'}
        className={styles.filterInputWrapper}></SingleSelectFilter>
    </section>
  )
}

SingleSelectFilterRolesFilter.propTypes = {
  roles: PropTypes.array,
  existingValue: PropTypes.string,
}

export default SingleSelectFilterRolesFilter
